import BaseComponent from 'foundation/base-component';
import eventBus from 'general/js/event-bus';
import ModalWithResult from 'general/js/modal-with-result';
import { EVENT_MODAL_CLOSE, bemClasses } from 'general/js/modal';

const CONTROL_BUTTON_HTML_PLAY = '<svg class="icon" width="25" height="25"><use xlink:href="#icon-play"></use></svg>';
const CONTROL_BUTTON_HTML_PAUSE = '<svg class="icon" width="25" height="25"><use xlink:href="#icon-pause"></use></svg>';

const CONTROL_BUTTON_HTML_MUTE = '<svg class="icon" width="25" height="25"><use xlink:href="#icon-mute"></use></svg>';
const CONTROL_BUTTON_HTML_UNMUTE = '<svg class="icon" width="25" height="25"><use xlink:href="#icon-unmute"></use></svg>';

export default class VideoComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.placeholder = this.refs.placeholder;
        this.playBtn = this.refs.playBtn;
        this.modalContent = this.refs.modalContent;
        this.control = this.refs.control;
        this.playControl = this.refs.playControl;
        this.muteControl = this.refs.muteControl;

        this.modal = null;
        this.onPlayClick = this.onPlayClick.bind(this);
        this.onClickPlayControl = this.onClickPlayControl.bind(this);
        this.onClickMuteControl = this.onClickMuteControl.bind(this);
        this.onModalClose = this.onModalClose.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['playBtn', 'modalContent', 'control', 'playControl', 'muteControl'];
    }

    init() {
        if (this.control.canPlayType) {
            this.playBtn.addEventListener('click', this.onPlayClick);

            if (this.placeholder) {
                this.placeholder.addEventListener('click', this.onPlayClick);
            }
        }

        eventBus.addListener(EVENT_MODAL_CLOSE, this.onModalClose);
    }

    onDestroy() {
        eventBus.removeListener(EVENT_MODAL_CLOSE, this.onModalClose);
    }

    onPlayClick() {
        this.getModal().open().catch(() => {
            // we assume the only case of modal rejection is when it closes
            this._pause();
        });
        this._play();
    }

    getModal() {
        if (this.modal === null) {
            this.modal = new ModalWithResult(this.modalContent, {
                bemList: [bemClasses.WIDE],
            });
            this.renderControls();
            this.playControl.addEventListener('click', this.onClickPlayControl);
            this.muteControl.addEventListener('click', this.onClickMuteControl);
        }

        return this.modal;
    }

    onClickPlayControl() {
        if (this.control.paused || this.control.ended) {
            this._play();
        } else {
            this._pause();
        }
    }

    onClickMuteControl() {
        if (this.control.muted === true) {
            this._unmute();
        } else {
            this._mute();
        }
    }

    _play() {
        this.control.play();
        this.playControl.innerHTML = CONTROL_BUTTON_HTML_PAUSE;
        this.playControl.setAttribute('aria-label', 'pause');
    }

    _pause() {
        this.control.pause();
        this.playControl.innerHTML = CONTROL_BUTTON_HTML_PLAY;
        this.playControl.setAttribute('aria-label', 'play');
    }

    _mute() {
        this.control.muted = true;
        this.muteControl.innerHTML = CONTROL_BUTTON_HTML_UNMUTE;
        this.muteControl.setAttribute('aria-label', 'unmute');
    }

    _unmute() {
        this.control.muted = false;
        this.muteControl.innerHTML = CONTROL_BUTTON_HTML_MUTE;
        this.muteControl.setAttribute('aria-label', 'mute');
    }

    renderControls() {
        this.playControl.innerHTML = CONTROL_BUTTON_HTML_PLAY;
        this.playControl.setAttribute('aria-label', 'play');
        this.muteControl.innerHTML = CONTROL_BUTTON_HTML_MUTE;
        this.muteControl.setAttribute('aria-label', 'mute');
    }

    onModalClose(modalContainer) {
        if (modalContainer && modalContainer.contains(this.element)) {
            this._pause();
        }
    }
}
